import {
  COLOR_SCALES,
  getColorScaleByHues,
  getColorScaleByValue,
} from '../../../utils/colorScales';

interface BackendColorScale {
  id: number;
  sHue: number;
  eHue: number;
}

export function getBackendColorScaleFromFrontend(
  frontendColorScale: string,
): BackendColorScale {
  const { id, sHue, eHue } = getColorScaleByValue(frontendColorScale);
  return { id, sHue, eHue };
}

export function getFrontendColorScaleFromBackend(
  backendColorScale: BackendColorScale | undefined,
): string {
  // Default value for new reports (no backend scale yet).
  if (!backendColorScale) {
    return COLOR_SCALES[0].value;
  }

  const { sHue, eHue } = backendColorScale;
  return getColorScaleByHues(sHue, eHue)?.value ?? COLOR_SCALES[0].value;
}
